(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/grassroots-shared/assets/javascripts/views/cards-nav.js') >= 0) return;  svs.modules.push('/modules/grassroots-shared/assets/javascripts/views/cards-nav.js');

(function(Backbone, _, svs) {
  'use strict';

  svs.grassroots.views.CardsNav = Marionette.View.extend({
    template: function(data) {
      return svs.grassroots.templates.cards_nav(data);
    },

    events: {
      'click .js-navigate': 'navigate',
      'click .js-login': 'login'
    },
    modelEvents: {
      change: 'render'
    },
    templateContext: {
      grassrootsChooseClub: svs.grassroots.data.config.grassrootsChooseClub
    },
    className: 'grassroots-wrapper animate animate-show animate-time-2ms',
    initialize: function() {
      this.model = new Backbone.Model({
        receivers: svs.grassroots.data.receiversCollection,
        myReceivers: this.setUpMyReceivers()
      });
      this.listenTo(
        svs.grassroots.collections.grassroots,
        'change',
        this.render
      );
    },
    onRender: function() {
      this.model.set('myReceivers', this.setUpMyReceivers);
    },
    setUpMyReceivers: function() {
      var tempReceivers = svs.grassroots.collections.grassroots.where({
        myReceiver: true
      });

      var myReceivers = [];
      if (tempReceivers.length) {
        for (var i = 0; i < 3; i++) {
          if (tempReceivers[i]) {
            myReceivers.push(tempReceivers[i].attributes);
          } else {
            myReceivers.push({ emptySlot: true, slotNr: i + 1 });
          }
        }
      } else {
        myReceivers = false;
      }
      return myReceivers;
    },
    navigate: function(e) {
      if (e.currentTarget && e.currentTarget.getAttribute('data-url')) {
        var url = e.currentTarget
          .getAttribute('data-url')
          .substring(e.currentTarget.getAttribute('data-url').lastIndexOf('/'));
        svs.components.revealAnimation.runRevealAnimation(e, function() {
          svs.grassroots.router.navigate(url, {
            trigger: true,
            silent: false,
            replace: false
          });
        });
        return false;
      }
      return true;
    },
    onAttach: function() {
      if (
        svs.grassroots.data.config.startPageConfig &&
        svs.grassroots.data.config.startPageConfig.promo &&
        svs.grassroots.data.config.startPageConfig.promo.startPageBackground &&
        svs.grassroots.data.config.startPageConfig.promo.startPageBackground.url
      ) {
        var backgroundUrl = svs.grassroots.data.config.startPageConfig.promo.startPageBackground.url.replace(
          '{width}',
          1280
        );
        if (backgroundUrl.indexOf('/cms/') >= 0) {
          backgroundUrl = svs.core.config.data.svsconfig.cdn2 + backgroundUrl;
        } else {
          backgroundUrl = svs.core.config.data.svsconfig.cdn + backgroundUrl;
        }
        $('.js-card-overview').css({
          'background-image': 'url(' + backgroundUrl + ')',
          'background-repeat': 'no-repeat',
          'background-size': 'cover',
          'background-position': 'center'
        });
      }
    },
    login: function() {
      svs.components.customer_login.login();
      return false;
    }
  });
})(Backbone, _, svs);


 })(window);